import styled from 'styled-components'
import { TOOLBAR_WIDTH_DESKTOP, SUMMARY_PANEL_WIDTH_DESKTOP } from '../../constants/constants'
import { APP_HEADER_FIXED_HEIGHT } from '../AppHeader/styles'

const TABS_CONTAINER_HEIGHT = '65px'

export const Toolbar = styled.div<{
  isEditItemPanelActive?: boolean
  hasSelectedTab?: boolean
}>`
  padding-bottom: 15px;
  background-color: transparent;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (min-width: 1200px) {
    position: relative; // Due to configurator view background effect
  }

  & > .react-tabs {
    display: ${(props) => (props.isEditItemPanelActive ? 'none' : 'flex')};
    flex-direction: column;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;

    & > * > .react-tabs__tab-list {
      display: flex;
      justify-content: space-evenly;
      align-items: flex-start;
      column-gap: 4px;
      overflow-x: ${(props) => (props.hasSelectedTab ? 'visible' : 'auto')};
      height: ${TABS_CONTAINER_HEIGHT};
      margin-top: 23px;
      margin-bottom: 5px;
      border-bottom: none;
      padding: 0 5px;
      transform: translateY(-18px);

      @media (min-width: 1200px) {
        margin-bottom: -5px;
        padding: 0 10px;
      }

      .react-tabs__tab {
        border: 1px solid transparent;
        border-radius: 50%;
        background-color: #d5dbd7;
        font-weight: 600;
        display: inline-flex;
        width: 48px;
        height: 48px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        pointer-events: all;

        @media (hover: hover) {
          &:hover {
            background-color: #ffffff;
            box-shadow:
              0px 1px 3px 1px rgba(0, 0, 0, 0.15),
              0px 1px 2px 0px rgba(0, 0, 0, 0.3);
          }
        }

        img {
          width: 21px;
          height: 21px;
        }

        span {
          position: absolute;
          bottom: -21px;
          font-size: 12px;
          font-weight: 400;
        }

        .fa-exclamation {
          color: ${(props) => props.theme.palette.info.main};
          background-color: #ffffff;
          border: 2px solid ${(props) => props.theme.palette.info.main};
          border-radius: 100px;
          position: absolute;
          top: -10px;
          right: 0;
          width: 19px;
          height: 19px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 11px;
        }

        &.react-tabs__tab--selected {
          border: 1px solid ${(props) => props.theme.palette.success.light};
          background-color: #ffffff;
          box-shadow:
            0px 1px 3px 1px rgba(0, 0, 0, 0.15),
            0px 1px 2px 0px rgba(0, 0, 0, 0.3);

          span {
            font-weight: 600;
          }
        }

        &:focus:after {
          display: none;
        }
      }
    }

    & > .react-tabs__tab-panel {
      padding: 10px 30px 45px;
      background-color: #ffffff;
      margin-top: 0;
      height: calc(100vh - ${APP_HEADER_FIXED_HEIGHT} - 160px);
      overflow-y: auto;

      @media (min-width: 768px) {
        height: calc(100vh - ${APP_HEADER_FIXED_HEIGHT} - 190px);
        margin-top: 22px; // needs to be improved
      }

      @media (min-width: 1024px) {
        margin-top: 55px;
      }

      @media (min-width: 1200px) {
        box-sizing: border-box;
        max-width: 100%;
        min-width: 100%;
        border: 1px solid #bfc9c3;
        box-sizing: border-box;
        margin-top: 0;
      }

      /* Inner tabs */
      & > .react-tabs {
        & > .react-tabs__tab-list {
          margin-top: 15px;

          // needs improvement (font-size)
          .react-tabs__tab {
            font-size: 14px;
            padding-right: 15px;
            padding-left: 15px;

            @media (min-width: 375px) {
              font-size: 15px;
            }

            @media (min-width: 390px) {
              font-size: 16px;
            }

            @media (min-width: 1200px) {
              font-size: 18px;
            }

            &.react-tabs__tab--selected {
              background-color: #ffffff;
              font-weight: 600;
              border: none; // reset CSS from react-tabs
              border-bottom: 4px solid ${(props) => props.theme.palette.primary.main};
            }

            &:focus:after {
              content: unset; // reset CSS from react-tabs
              left: -1000px; // reset CSS from react-tabs
              background-color: transparent; // reset CSS from react-tabs
            }
          }
        }

        & > .react-tabs__tab-panel {
          padding-top: 15px;
        }
      }
    }
  }
`

export const ToolbarContainer = styled.div<{
  insideSummaryPanel?: boolean
}>`
  display: flex;
  flex-direction: column;

  @media (min-width: 1200px) {
    min-width: ${(props) => (props.insideSummaryPanel ? SUMMARY_PANEL_WIDTH_DESKTOP : TOOLBAR_WIDTH_DESKTOP)};
    max-width: ${(props) => (props.insideSummaryPanel ? SUMMARY_PANEL_WIDTH_DESKTOP : TOOLBAR_WIDTH_DESKTOP)};
    overflow: ${(props) => (props.insideSummaryPanel ? 'auto' : 'hidden')};

    h1 {
      margin-bottom: 20px;
    }
  }
`

export const TabsContainer = styled.div`
  position: relative;
`
